import { imagePath } from '@lib/imgproxy';

/** Anything a swatch is drawn from: its flat colour, and the picture it is drawn with instead, if any. */
export type SwatchColor = { r: number; g: number; b: number; swatchUrl?: string | null };

/**
 * The CSS for a box showing a colour: its picture where it has one — a print, whose RGB is only an
 * average of it — otherwise its flat colour. The flat colour stays underneath while the picture loads.
 * `size` is the box's size in pixels, so the picture is fetched no larger than it is drawn.
 */
export function swatchStyle(color: SwatchColor, size = 48): Record<string, string> {
  const flat = `rgb(${color.r}, ${color.g}, ${color.b})`;
  if (!color.swatchUrl) return { backgroundColor: flat };

  return {
    backgroundColor: flat,
    backgroundImage: `url("${imagePath(color.swatchUrl, size * 2, size * 2, 'fill')}")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };
}
